/**
 * Theme Configuration
 * 
 * This file contains configuration options for the application's theming system.
 * The default theme is resolved from brandConfig (biocv → 'default', biotagplus → 'v2').
 */
import brandConfig from './config/brandConfig';

const themeConfig = {
  // Resolved from REACT_APP_BRAND at build time via brandConfig
  defaultTheme: brandConfig.theme || 'default',
  
  // Whether to allow theme switching in the UI
  // If set to false, the ThemeSwitcher component will not be rendered
  allowThemeSwitching: brandConfig.allowThemeSwitching === true,
  
  // Whether to save the user's theme preference to localStorage
  // If true, the application will remember the user's theme choice between sessions
  persistThemePreference: true,
  
  // The local storage key to use for saving theme preference
  localStorageKey: `lisa-theme-preference:${brandConfig.id}`,
};

export default themeConfig;
